import { useRestrictedFields } from "../context/RestrictedFieldsContext";
import { useRestrictedToggle } from "../context/RestrictedToggleContext";
import { isFieldRestricted } from "../Utils/fieldVisibility";

export default function withRestrictions(WrappedComponent) {
  return function WithRestrictions(props) {
    const restrictedList = useRestrictedFields();
    const { restrictedUnlocked } = useRestrictedToggle();
    const { idField, enableEdit: enableEditProp, ...rest } = props;

    const restricted = isFieldRestricted(idField, restrictedList);
    const isBlured = restricted;

    const wrapperProps = {
      ...rest,
      idField,
      isBlured,
      tooltip: restricted
        ? "This data will not render in AgriGuide app. So Please do not review"
        : "",
    };

    if (enableEditProp !== undefined) {
      // only include if explicitly provided
      wrapperProps.enableEdit = restricted ? false : enableEditProp;
    }

    return <WrappedComponent {...wrapperProps} />;
  };
}
